import React from 'react';

const PoliticalFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="5" y="4" width="10" height="6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="5" y="14" width="10" height="3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="8" y="10" width="4" height="4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 4H17" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 17L16 17" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default PoliticalFilterIcon;
